'use client';
import { Dispatch, FC, SetStateAction } from 'react';
import { DisplayedCarInfoInterface, LenderWithInterestRates } from '@/types';

import { useTranslation } from '@/hook';
import { Box } from '@mui/material';
import SwipeableDrawer from '@/components/shared/bottom-sheet/bottom-sheet.component';
import SylndrSwitch from '@/components/shared/Switch/index';
import Typography from '@/components/shared/typography/typography.component';

import FinancierButton from '../FinancierButton';

interface IFinancierComparision {
    lenders?: LenderWithInterestRates[];
    isOpen: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    carSellBan: boolean;
    setCarSellBan: Dispatch<SetStateAction<boolean>>;
    monthlyInstallments: string | null;
    carInfo: DisplayedCarInfoInterface;
    downpayment: number;
    months: number;
    mobileButtons?: JSX.Element;
}

const FinancierComparisonMobile: FC<IFinancierComparision> = ({
    lenders,
    isOpen,
    setOpen,
    carSellBan,
    setCarSellBan,
    monthlyInstallments,
    downpayment,
    months,
    mobileButtons,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <SwipeableDrawer open={isOpen} setOpen={setOpen}>
                <Box
                    sx={{
                        width: '100%',
                        paddingTop: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        maxHeight: '90vh',
                    }}
                >
                    <Box>
                        <Typography variant="subtitle2Medium">
                            {t('Financing options')}
                        </Typography>
                    </Box>
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                gap: '8px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Typography
                                    variant="body2Medium"
                                    style={{ color: '#344054' }}
                                >
                                    {t('monthly')}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    style={{ color: '#002D5D' }}
                                >
                                    {monthlyInstallments}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Typography
                                    variant="body2Medium"
                                    style={{ color: '#344054' }}
                                >
                                    {t('carSellBan')}
                                </Typography>
                                <SylndrSwitch
                                    onChange={e =>
                                        setCarSellBan(e.target.checked)
                                    }
                                    checked={carSellBan}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        {lenders?.map(lender => (
                            <FinancierButton
                                key={lender.id}
                                lender={lender}
                                carSellBan={carSellBan}
                                downpayment={downpayment}
                                fixed
                                months={months}
                            />
                        ))}
                    </Box>
                    <Box
                        sx={{
                            height: '96px',
                            position: 'sticky',
                            bottom: 0,
                            margin: '-16px',
                            width: '100vw',
                        }}
                    >
                        {mobileButtons}
                    </Box>
                </Box>
            </SwipeableDrawer>
        </>
    );
};

export default FinancierComparisonMobile;
